import styled from 'styled-components';

export const Page = styled.div`
    max-width: 1180px;
    margin: 0 auto;
    padding: 32px 16px 56px;
`;

export const Header = styled.div`
    margin-bottom: 24px;

    h1 {
        margin-bottom: 8px;
    }

    p {
        max-width: 760px;
        margin: 0;
        color: #595959;
        font-size: 16px;
        line-height: 1.6;
    }
`;

export const QuizPanel = styled.div`
    display: grid;
    gap: 22px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);

    @media (max-width: 767px) {
        padding: 16px;
    }
`;

export const QuizTopline = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
`;

export const Question = styled.div`
    display: grid;
    gap: 8px;

    h2 {
        margin: 0;
        font-size: clamp(24px, 4vw, 38px);
        line-height: 1.15;
    }

    p {
        margin: 0;
        color: #595959;
        font-size: 15px;
    }
`;

export const MapFrame = styled.div`
    width: 100%;
    min-height: 360px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    background: #f7fafc;
    overflow: hidden;
`;

export const CzechiaSvg = styled.svg`
    display: block;
    width: 100%;
    height: auto;
    min-height: 340px;
`;

export const OptionGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }
`;

export const ShapeStage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 340px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    background: #f8fafc;
`;

export const FinishedPanel = styled.div`
    display: grid;
    justify-items: start;
    gap: 16px;
`;
